import { ChartFrequency, IComposableChartsWidget } from 'wisestep-api';

import { reducedGeneralTimePeriodList } from '../../../../../features/analyticsPage/helper/timePeriodList';
import { RTRAnalyticsWidget } from '../../../../../features/composableAnalytics/BaseCharts/helper';
import RTRSplitMetricPostgres from '../../../../../features/composableAnalytics/BaseCharts/rtr/postgres/RTRSplitMetricPostgres';
import RTRStackedBarChartPostgres from '../../../../../features/composableAnalytics/BaseCharts/rtr/postgres/RTRStackedBarChartPostgres';
import RTRTablePostgres from '../../../../../features/composableAnalytics/BaseCharts/rtr/postgres/RTRTablePostgres';
import { ChartScope } from '../../../types';
import { getChartFreqForTimePeriod } from '../../helper';

const rtrWidgetsByTimeAndScope = (
  timePeriodId: string,
  scope: ChartScope,
  frequency: ChartFrequency = getChartFreqForTimePeriod[timePeriodId]
): Record<RTRAnalyticsWidget, IComposableChartsWidget> => {
  const defaultQuery = {
    category: 'rtr',
    filters: [],
    type: 'rtr-split-metric',
    range: timePeriodId,
    scope,
    frequency,
  };
  const widgetConfig: Record<RTRAnalyticsWidget, IComposableChartsWidget> = {
    [RTRAnalyticsWidget.RTR_SPLIT_METRIC]: {
      name: 'RTR by Status',
      filters: {},
      category: 'rtr',
      type: `metric_rtr_status_${timePeriodId}_${scope}_postgre`,
      component: (
        <RTRSplitMetricPostgres
          query={{
            ...defaultQuery,
            type: 'rtr-split-metric',
          }}
          title="RTR by Status"
          widgetName={RTRAnalyticsWidget.RTR_SPLIT_METRIC}
        />
      ),
    },
    [RTRAnalyticsWidget.RTR_RECRUITER_TABLE]: {
      name: `RTR by Recruiter`,
      filters: {},
      category: 'rtr',
      type: `table_rtr_recruiter_${timePeriodId}_${scope}_${frequency}_postgre`,
      component: (
        <RTRTablePostgres
          query={{
            ...defaultQuery,
            type: 'rtr-recruiter-table',
          }}
          title={`RTR by Recruiter`}
          widgetName={RTRAnalyticsWidget.RTR_RECRUITER_TABLE}
          widgetType={`table_rtr_recruiter_${timePeriodId}_${scope}_${frequency}_postgre`}
        />
      ),
    },
    [RTRAnalyticsWidget.RTR_JOB_TITLE_TABLE]: {
      name: 'RTR by Job Title',
      filters: {},
      category: 'rtr',
      type: `table_rtr_jab_title_${timePeriodId}_${scope}_postgre`,
      component: (
        <RTRTablePostgres
          query={{
            ...defaultQuery,
            type: 'rtr-job-title-table',
          }}
          title="RTR by Job Title"
          widgetName={RTRAnalyticsWidget.RTR_JOB_TITLE_TABLE}
          widgetType={`table_rtr_jab_title_${timePeriodId}_${scope}_postgre`}
        />
      ),
    },
    [RTRAnalyticsWidget.RTR_STACKED_BAR_CHART]: {
      name: 'RTR Trends',
      filters: {},
      category: 'rtr',
      type: `stackedbarchart_rtr_trends_${timePeriodId}_${scope}_postgre`,
      component: (
        <RTRStackedBarChartPostgres
          query={{
            ...defaultQuery,
            type: 'rtr-stacked-bar-chart',
          }}
          title="RTR Trends"
          widgetName={RTRAnalyticsWidget.RTR_STACKED_BAR_CHART}
        />
      ),
    },
  };
  return widgetConfig;
};

export const postgresRTRAnalyticsDashboardKeys = (
  timePeriodId: string,
  scope: ChartScope
): IComposableChartsWidget[] => {
  const defaultWidgetList = Object.values(rtrWidgetsByTimeAndScope(timePeriodId, scope));
  return [...defaultWidgetList];
};

export const postgresRTRAnalyticsDashboardKeysObjectList = reducedGeneralTimePeriodList.flatMap(
  (timePeriod) => [
    ...postgresRTRAnalyticsDashboardKeys(timePeriod?.id, ChartScope.WORKSPACE),
    ...postgresRTRAnalyticsDashboardKeys(timePeriod?.id, ChartScope.LOGGED_IN_USER),
  ]
);
